module.exports = __webpack_public_path__ + "static/media/5.71ac0f5a.jpg";